<template>
  <el-dialog title="充值到京东余额" :visible.sync="rechargeDialogVisible" width="450px" :before-close="handleClose"  :close-on-click-modal="false">
    <div>
      <el-form  :model="create" label-width="130px">
        <el-form-item label="余额(元)：" required>
          {{this.amount}}
        </el-form-item>
        <el-form-item label="充值金额(元)：" required>
          <inputValidate v-model.trim="create.applyAmount" type="money" />
        </el-form-item>
        <div class="text-c">
          <el-button size="small" @click="handleClose">取 消</el-button>
          <el-button size="small" type="primary" @click="commitHandle">确 定</el-button>
        </div>
      </el-form>
    </div>
    <div id='form-container'></div>
  </el-dialog>
</template>

<script>
import api from '@/api'

// 只允许苹果市场用户 目前苹果市场只对应一个渠道号 channelCode和marketId写死的
function Create () {
  this.channelCode = '002'
  this.userId = ''
  this.marketId = '10'
  this.applyAmount = ''
  this.callBackUrl = 'https://www.baidu.com'
  this.memo = ''
}

export default {
  name: 'jdEnterpriseTopUp',
  props: {
    rechargeDialogVisible: {
      type: Boolean,
      default: false
    }
  },
  components: {
  },

  data () {
    return {
      create: new Create(),
      amount: '', // 余额
      createRules: [
        { name: 'channelCode', message: '银行渠道必传' },
        { name: 'userId', message: '用户编号必传' },
        { name: 'marketId', message: '市场必传' },
        { name: 'applyAmount', message: '充值金额必传' },
      ]
    }
  },
  created () {
    this.create.userId = this.$store.state.user.info.userId
    this.handleShow()
  },
  methods: {
    handleClose () {
      this.$emit('toggleHandleCreate', false)
    },
    async handleShow () {
      let param = {
        userId: this.create.userId,
        channelCode: this.create.channelCode,
      }

      try {
        let res = await api.myAccount.getAccountInfo(param)
        this.amount = res.data.amount || 0
      } catch (e) {
        this.handleClose()
      }
    },
    // 确定新增
    commitHandle () {
      if (this.$utils.checkEmptyRules(this.create, this.createRules)) {
        return
      }
      api.myAccount.enterpriseTopUp(this.create).then(res => {
        this.$message.success('操作成功')
        const formContainer = document.getElementById('form-container')
        // 去掉"前的\
        formContainer.innerHTML = res.data.replace(/\\"/g, '"')
        const thisForm = formContainer.getElementsByTagName('form')[0]
        thisForm.target = '_blank'
        // 再次修改input内容
        thisForm.submit()
        this.handleClose()
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.gobal-form{
  .el-input, .el-input__inner{
    width:217px !important;
  }
  div.input-val{
    display:inline-block;
    width:217px;
  }
}
#form-container {
  visibility: hidden;
  position: absolute;
}
</style>
